import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin:0 10px 0 0;
`
export const Wrapper = styled.div`
  margin: 30px 0 0 20px;
`
export const Title = styled.div`
  font-size: 25px;
  font-weight: 500;
  margin-bottom: 40px;
`
export const Button = styled.div`
  font-weight: 600;
  color: white;
  background-color: #5ECE7B;
  height: 40px;
  width: 210px;
  display: flex;
  justify-content: center;
  border-radius: 3px; 
  opacity: 0.85;
  font-size: 15px;
  cursor: pointer;
  margin: 13px 0;
  align-items: center;  
`
export const TaxInfo = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 0.5px solid #E5E5E5;
  margin-right: 40px;
`
export const Items = styled.div`
  margin-top: 10px;
  font-size: 20px;
  font-weight: 100;
`
export const EmptyCart = styled.div`
  font-size: 20px;
  font-weight: 100;
  margin-bottom: 10px;
`